module.exports = __webpack_public_path__ + "img/logo.2939f9b6.svg";